<template>
  <qtm-content-block v-bind="$attrs" title="Quote Request Details">
    <v-row no-gutters>
      <v-col class="pr-4" cols="6">
        <details-container :details="orderDetails" label-size="8em">
          <template v-if="order.delivery_time === 'hold'" v-slot:date>
            <qtm-chip color="secondary" text-color="white">
              HOLD FOR RELEASE
            </qtm-chip>
          </template>
          <template v-slot:location>
            <div class="text-capitalize" v-text="order.delivery_location" />
            <qtm-address :address="order.address" :city="order.city" :province="order.province" />
          </template>
        </details-container>
      </v-col>

      <v-divider class="my-3" vertical />

      <v-col class="pl-4" cols="6">
        <details-container :details="quoteDetails" label-size="8em" />
      </v-col>
    </v-row>
  </qtm-content-block>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import DetailsContainer from '~/components/details-container.vue'
import { conciseDate, objectDeliveryDate } from '~/models/filters'

export interface Props {
  order: Order
}

const props = defineProps<Props>()

const deliveryDateText = computed(() => {
  if (props.order.delivery_time === 'tbd') {
    return "Don't know date & time yet"
  }
  return objectDeliveryDate(props.order)
})

const pickupOrDelivery = computed(() => props.order.customer_pickup ? 'Pickup' : 'Delivery')
const orderDetails = computed(() => [
  { label: `${pickupOrDelivery.value} Date`, text: deliveryDateText.value, value: 'date' },
  { label: 'Delivery Location', value: 'location', exclude: !!props.order.customer_pickup },
].filter(detail => !detail.exclude))

const quoteDetails = computed(() => [
  { label: 'Quote Due Date', text: conciseDate(props.order.date_closes), value: 'date' },
])
</script>
